<template>
  <div class="cart">
    <div class="row mr-auto">
      <h2 class="col-12 title">{{ title }}</h2>
      <p class="col-12" v-show="!cart.length">
        <i>Your cart is empty!</i>
        <button @click="toCatalog">Go to catalog</button>
      </p>
    </div>
    <div class="row">
      <table class="col-12 table is-striped" v-show="cart.length">
        <thead>
          <tr>
            <td><h6 class="">Product Name</h6></td>
            <td><h6 class="">Product Price</h6></td>
            <!-- <td>Quantity</td> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(p) in cart" :key = "p">  
            <td>{{ p.name }}</td>
            <td>${{ p.price }}</td>
            <!-- <td>{{ p.quantity }}</td> -->
          </tr>
          <tr>
            <td><b>Total:</b></td>
            <td></td>
            <td><b>${{ total }}</b></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div id="payment-request-button">
      <!-- A Stripe Element will be inserted here. -->
    </div>
    <!-- <p><button v-show="cart.length" class='button is-primary'>Checkout</button></p> -->
    <div v-if="cart.length > 0 && noCart != 'yes'" class="row mr-auto align-items-end">
      <div class="col-sm-8 col-md-6"></div>
    
      <router-link tag="div" class="col-sm-4 col-md-6 btn btn-primary"
        :to="{ name: 'checkout', params: { language: 'en' }}">
        Checkout
      </router-link>
     
    </div>

  </div>
</template>

<script>
  //import Log from 'loglevel';
  import {
    mapLang
  } from "../routes.js";

  // import Stripe from 'https://checkout.stripe.com/checkout.js';
  // import { mapGetters } from 'vuex'
  export default {
    name: "Cart",
    data: function() {
      return {
        language: this.$route.params["language"],
        startPay: false,
        server: "https://www.aquawiz.net",
        handler: null
      }
    },
    components: { },
    computed: {
      inCart() {
        return this.$store.getters.inCart;
      },
      numInCart() {
        return this.$store.getters.inCart.length;
      },
      cart() {
        console.log("props: ", this.language, this.noCart, this);
        // return this.$store.inCart.inCart.map((cartItem) => {
        //   return this.$store.inCart.forSale.find((forSaleItem) => {
        //     return cartItem === forSaleItem.invId;
        //   });
        // });
        return this.$store.getters.inCart;
      },

      created() {
        // let Stripe = document.createElement('script');
        // Stripe.setAttribute('src', 'https://checkout.stripe.com/checkout.js');
        // document.head.appendChild(Stripe);
        // console.log("creating: ", Stripe);

        // document.getElementById('customButton').addEventListener('click', function(e) {
        //   // Open Checkout with further options:
        //   handler.open({
        //     name: 'aquawiz.net',
        //     description: '2 widgets',
        //     amount: 2000
        //   });
        //   e.preventDefault();
        // });
        // // Close Checkout on page navigation:
        // window.addEventListener('popstate', function() {
        //   handler.close();
        // });
      },
      total() {
        return this.$store.getters.inCart.reduce((total, p) => {
          return total + p.price
        }, 0)
      },
      mapLang() { return mapLang() }
    },

    filters: {
      dollars: num => `$${num}`
    },
    methods: {
      toCatalog() {
        this.$router.push({ name: 'catalog', params: this.$route.params });
      },
      checkout() {
        console.log("sending payment: ", StripeCheckout);
        let handler = StripeCheckout.configure({
          key: 'pk_test_PQ5TCuMnTBi2A1viAcI47KQe',
          //image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
          locale: 'auto',
          token: function(token) {
            // You can access the token ID with `token.id`.
            // Get the token ID to your server-side code for use.
            console.log('token: ', token);
          }
        });
          handler.open({
            name: 'aquawiz.net',
            description: 'AquaWiz Payments',
            amount: this.total * 100
          });
      }
    },
    // props:['language', "noCart", "title"],
    props: {
      // language: { },
      noCart: { default: 'no' },
      title: { default: 'Shopping Cart' }
    }
  }
</script>


<style>

</style>


// WEBPACK FOOTER //
// Cart.vue?91d7dfe8